import { render, staticRenderFns } from "./Footbar.vue?vue&type=template&id=4b9be60f&scoped=true"
import script from "./Footbar.vue?vue&type=script&lang=js"
export * from "./Footbar.vue?vue&type=script&lang=js"
import style0 from "./Footbar.vue?vue&type=style&index=0&id=4b9be60f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9be60f",
  null
  
)

export default component.exports